import React from "react";
import Automationone from "../components/Section/Automotive-Metal-Steet-one"
import Automationtwo from "../components/Section/Automotive-Metal-Steet.two"

function Automation() {
 

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
    
        <Automationone />
        <Automationtwo />
      
    </div>
  );
}

export default Automation;